import React, { useState, useEffect } from 'react';
import { Navbar as BootstrapNavbar, Nav, NavDropdown, Container, Button, Offcanvas } from 'react-bootstrap';
import './navbarsection.css';
import logo from '../../../assets/images/TradeMark_Logo.png';
import RegisterFlow from '../registerflow/registerflow';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const Navbarsection = () => {
  const [showSidebar, setShowSidebar] = useState(false);
  const [activeLink, setActiveLink] = useState('employer');
  const [showResources, setShowResources] = useState(false);
  const [registerPopupVisible, setRegisterPopupVisible] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    switch (location.pathname) {
      case '/navbar-faq':
      case '/resources-blog':
      case '/pricing-prelogin':
      case '/policy':
      case '/contact-us':
      case '/about-us':
        setActiveLink('resources');
        setShowResources(true);
        break;
      case '/employer':
        setActiveLink('employer');
        setShowResources(false);
        break;
      case '/candidate-homepage':
        setActiveLink('candidate-homepage');
        setShowResources(false);
        break;
      case '/career-guidance':
        setActiveLink('career-guidance');
        setShowResources(false);
        break;
      default:
        setActiveLink('');
        setShowResources(false);
        break;
    }
  }, [location.pathname]);

  const handleSidebarClose = () => setShowSidebar(false);
  const handleSidebarShow = () => setShowSidebar(true);

  const handleLinkClick = (link) => {
    setActiveLink(link);
    if (link !== 'resources') {
      setShowResources(false);
    }
  };

  const toggleResources = () => {
    setActiveLink('resources');
    setShowResources(!showResources);
  };

  const handleRegisterClick = () => {
    // navigate('/registration');
    setRegisterPopupVisible(true);
    handleSidebarClose();
  };

  const closeRegisterPopup = () => {
    setRegisterPopupVisible(false);
  };


  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 991 && showSidebar) {
        setShowSidebar(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [showSidebar]);

  return (
    <div>
      <BootstrapNavbar expand="lg" className="custom-navbar">
        <Container className="d-flex justify-content-between align-items-center" >
          <div className="d-flex align-items-center">
            <BootstrapNavbar.Toggle aria-controls="navbar-nav" onClick={handleSidebarShow} />
            <BootstrapNavbar.Brand href='/'>
              <img src={logo} alt="Logo" className="navbar-logo" />
            </BootstrapNavbar.Brand>
          </div>
          <BootstrapNavbar.Collapse>
            <Nav className="mx-auto d-none d-lg-flex">
              <Nav.Link
                as={Link}
                to="/login"
                className={`custom-nav-link ${activeLink === 'employer' ? 'active' : ''}`}
                onClick={() => {
                  handleLinkClick('employer');
                }}
              >
                Employer
              </Nav.Link>

              <Nav.Link
                as={Link}
                to="/candidate-homepage"
                className={`custom-nav-link ${activeLink === 'candidate-homepage' ? 'active' : ''}`}
                onClick={() => handleLinkClick('candidate-homepage')}
              >
                Candidate
              </Nav.Link>

              <Nav.Link
                as={Link}
                to="/career-guidance"
                className={`custom-nav-link ${activeLink === 'career-guidance' ? 'active' : ''}`}
                onClick={() => handleLinkClick('career-guidance')}
              >
                Career Guidance
              </Nav.Link>

              <NavDropdown
                title={
                  <span className={`custom-nav-link ${activeLink === 'resources' ? 'active' : ''}`}>Resources</span>
                }
                className="custom-nav-link"
                onClick={() => handleLinkClick('resources')}
              >
                <NavDropdown.Item
                  as={Link}
                  to="/about-us"
                  className={`navbar-link ${location.pathname === '/about-us' ? 'active' : ''}`}
                >
                  About Us
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  to="/resources-blog"
                  className={`navbar-link ${(location.pathname === '/resources-blog' || location.pathname === '/blogdetails') ? 'active' : ''}`}
                >
                  Blog
                </NavDropdown.Item>
                {/* <NavDropdown.Item
                  as={Link}
                  to="/policy"
                  className={`navbar-link ${location.pathname === '/policy' ? 'active' : ''}`}
                >
                  Policy
                </NavDropdown.Item> */}
                <NavDropdown.Item
                  as={Link}
                  to="/navbar-faq"
                  className={`navbar-link ${location.pathname === '/navbar-faq' ? 'active' : ''}`}
                >
                  FAQ
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  to="/pricing-prelogin"
                  className={`navbar-link ${location.pathname === '/pricing-prelogin' ? 'active' : ''}`}
                >
                  Pricing
                </NavDropdown.Item>


                <NavDropdown.Item
                  as={Link}
                  to="/contact-us"
                  className={`navbar-link ${location.pathname === '/contact-us' ? 'active' : ''}`}
                >
                  Contact Us
                </NavDropdown.Item>
              </NavDropdown>
            </Nav>
            <div className="auth-buttons d-none d-lg-flex">
              <Button variant="orange" className="custom-login" href="/login">
                Login
              </Button>
              <Button variant="none" className="custom-register" onClick={handleRegisterClick}>
                Register
              </Button>
              {/* <Button variant="none" className="custom-register" > */}
              {/* Register */}
              {/* </Button> */}
            </div>
          </BootstrapNavbar.Collapse>
        </Container>
      </BootstrapNavbar>

      <Offcanvas show={showSidebar} onHide={handleSidebarClose} placement="start" className="sidebar-nav">
        <Offcanvas.Header closeButton className='sidebar-navbar-close'>
          <a href="/">
            <img src={logo} alt="Logo" className="sidebar-logo" />
          </a>
        </Offcanvas.Header>
        <hr className="sidebar-divider" />
        <Offcanvas.Body className="d-flex flex-column">
          <Nav className="flex-column align-items-start w-100">
            <div className="sidebar-link-container">
              <Nav.Link
                as={Link}
                to="/login"
                className={`sidebar-link ${activeLink === 'employer' ? 'active-sidebar-link' : ''}`}
                onClick={() => {
                  handleLinkClick('employer');
                  handleSidebarClose();
                }}
              >
                Employer
              </Nav.Link>
            </div>
            <div className="sidebar-link-container">
              <Nav.Link
                as={Link}
                to="/candidate-homepage"
                className={`sidebar-link ${activeLink === 'candidate-homepage' ? 'active-sidebar-link' : ''}`}
                onClick={() => {
                  handleLinkClick('candidate-homepage');
                  handleSidebarClose();
                }}
              >
                Candidate
              </Nav.Link>
            </div>
            <div className="sidebar-link-container">
              <Nav.Link
                as={Link}
                to="/career-guidance"
                className={`sidebar-link ${activeLink === 'career-guidance' ? 'active-sidebar-link' : ''}`}
                onClick={() => {
                  handleLinkClick('career-guidance');
                  handleSidebarClose();
                }}
              >
                Career Guidance
              </Nav.Link>
            </div>
            <div
              className={`sidebar-link resources-link ${activeLink === 'resources' ? 'active-sidebar-link' : ''}`}
              onClick={toggleResources}

            >
              Resources <span className="arrow">{showResources ? '^' : '>'}</span>
            </div>
            {showResources && (
              <div className="resources-dropdown">
                <Nav.Link
                  as={Link}
                  to="/about-us"
                  className={`sidebar-link ${location.pathname === '/about-us' ? 'active-sidebar-link' : ''}`}
                  onClick={() => {
                    handleSidebarClose();
                  }}
                >
                  About Us
                </Nav.Link>
                <Nav.Link
                  as={Link}
                  to="/resources-blog"
                  className={`sidebar-link ${location.pathname === '/resources-blog' || location.pathname === '/blogdetails'
                    ? 'active-sidebar-link'
                    : ''
                    }`}
                  onClick={() => {
                    handleSidebarClose();
                  }}
                >
                  Blog
                </Nav.Link>
                {/* <Nav.Link
                  as={Link}
                  to="/policy"
                  className={`sidebar-link ${location.pathname === '/policy' ? 'active-sidebar-link' : ''}`}
                  onClick={() => {
                    handleSidebarClose();
                  }}
                >
                  Policy
                </Nav.Link> */}
                <Nav.Link
                  as={Link}
                  to="/navbar-faq"
                  className={`sidebar-link ${location.pathname === '/navbar-faq' ? 'active-sidebar-link' : ''}`}
                  onClick={() => {
                    handleSidebarClose();
                  }}
                >
                  FAQ
                </Nav.Link>
                <Nav.Link as={Link}
                  to="/pricing-prelogin"
                  className={`sidebar-link ${location.pathname === '/pricing-prelogin' ? 'active-sidebar-link' : ''}`}
                  onClick={() => {
                    handleSidebarClose();
                  }}
                >
                  Pricing
                </Nav.Link>


                <Nav.Link
                  as={Link}
                  to="/contact-us"
                  className={`sidebar-link ${location.pathname === '/contact-us' ? 'active-sidebar-link' : ''}`}
                  onClick={() => {
                    handleSidebarClose();
                  }}
                >
                  Contact Us
                </Nav.Link>
              </div>
            )}
          </Nav>

          <hr className="sidebar-divider w-100" />
          <div className="w-100">
            <Button variant="light" className="sidebar-register-btn w-100 mt-2" onClick={handleRegisterClick}>
              Register
            </Button>
            <Button variant="outline-orange" className="custom-login w-100" href="/login" >
              Login
            </Button>
            <br />
            <br />
            <br />
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      {/* Register popup */}
      <RegisterFlow visible={registerPopupVisible} onClose={closeRegisterPopup} />
    </div>
  );
};

export default Navbarsection;
